module.exports = __webpack_public_path__ + "img/hkie2.692fecf9.png";